<div class="engine-scroll" data-test="engineScroll" *ngIf="show" @show (@show.done)="onShowDone()">
  <div class="engine-scroll__label">
      Use control + scroll to zoom
  </div>
</div>
